module.exports = __webpack_public_path__ + "img/violet_071.4aeba5b8.png";